import { Button, Dialog, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import theme from "../../../muiTheme";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";

interface CancelModalProps {
  open: boolean;
  handleClose: () => void;
}

const ManagementsCancelProcess: React.FC<CancelModalProps> = ({
  open,
  handleClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={handleClose} className="eBills-dialog">
      <Stack gap={"1.5rem"} paddingBottom={{ xs: "1rem", md: "2.5rem" }}>
        <Stack direction={"row"} padding={0} justifyContent="space-between">
          <Typography variant="h2" component="p">
            {t("Gestiones.¿Estás seguro que quieres salir?")}
          </Typography>
          <Button onClick={handleClose} sx={{ alignSelf: "start" }}>
            <Typography fontSize="32px" color={theme.palette.grey[900]}>
              <span className="t-icon-close"></span>
            </Typography>
          </Button>
        </Stack>
        <Typography variant="subtitle1" component="p">
          {t("Gestiones.Si sales ahora no se van a guardar los cambios.")}
        </Typography>
      </Stack>
      <Stack gap={"1rem"}>
        <ButtonElement onClick={handleClose}>
          {t("Gestiones.No, continuar")}
        </ButtonElement>
        <ButtonElement
          secondary
          onClick={() => navigate(`${process.env.REACT_APP_MANAGEMENT}`)}
        >
          {t("Gestiones.Sí, quiero salir")}
        </ButtonElement>
      </Stack>
    </Dialog>
  );
};

export default ManagementsCancelProcess;
